import axios from 'axios';

const INFINITE_SCROLL_MARGIN = 800;
const INFINITE_SCROLL_URLS = {
    news: '/news/items'
};

const InfiniteScroll = {
    init() {
        this.scrollNode = document.getElementById('infinitescroll');

        if (!this.scrollNode) {
            return;
        }

        const type = this.scrollNode.dataset.type;

        if (!INFINITE_SCROLL_URLS[type]) {
            return;
        }

        this._infiniteScrollUrl = INFINITE_SCROLL_URLS[type];
        this._infiniteScrollPage = 2;
        this._endReached = false;

        // window.addEventListener('scroll', this._trackInfiniteScroll.bind(this));
        // this._trackInfiniteScroll();

        this._addLinkNode();
    },

    _startLoading() {
        this._scrollLoading = true;

        const element = document.createElement('div');
        element.className = 'loading-container';

        const wheel =  document.createElement('div');
        wheel.className = 'loading-wheel';

        element.appendChild(wheel);

        this.scrollNode.appendChild(element);
        this.scrollNode.removeChild(this._linkNode);

        this.loadingNode = element;
    },

    _endLoading() {
        this._scrollLoading = false;
        this.scrollNode.removeChild(this.loadingNode);
    },

    _addLinkNode() {
        const element = document.createElement('div');
        element.className = 'load-more';

        const link = document.createElement('a');
        link.href = '';
        link.className = 'action-button';
        link.textContent = Exanimo.trans('load_more');
        link.onclick = (e) => {
            e.preventDefault();
            this._loadMore();
        };

        element.appendChild(link);

        this.scrollNode.appendChild(element);

        this._linkNode = element;
    },

    _loadMore() {

        this._startLoading();

        axios.get(`${this._infiniteScrollUrl}?page=${this._infiniteScrollPage}`).then((response) => {

            if (!response.data) {
                this._endReached = true;
                this._endLoading();
                return;
            }

            this._endLoading();

            this.scrollNode.insertAdjacentHTML('beforeend', response.data);

            this._infiniteScrollPage++;

            this._addLinkNode();

        }).catch(() => {
            this._endReached = true;
            this._endLoading();
        });
    },

    _trackInfiniteScroll() {

        if (this._scrollLoading || this._endReached) {
            return;
        }

        if (document.body.clientHeight - window.innerHeight - window.scrollY > INFINITE_SCROLL_MARGIN) {
            return;
        }

        this._startLoading();

        axios.get(`${this._infiniteScrollUrl}?page=${this._infiniteScrollPage}`).then((response) => {

            if (!response.data) {
                this._endReached = true;
                this._endLoading();
                return;
            }

            this._endLoading();

            this.scrollNode.insertAdjacentHTML('beforeend', response.data);

            this._infiniteScrollPage++;
        }).catch(() => {
            this._endReached = true;
            this._endLoading();
        });
    },
};

export default InfiniteScroll;